import { render, staticRenderFns } from "./work-password.vue?vue&type=template&id=3b46163a"
import script from "./work-password.vue?vue&type=script&lang=ts"
export * from "./work-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports